﻿import { FunctionComponent, useState } from "react";
import { Card, CardBody, CardFooter, CardHeader, Divider, Flex, Icon, IconButton, Stack, StackDivider, Text } from "@chakra-ui/react";
import { IconTrash } from "@tabler/icons-react";
import { CandidateCommentParameter, useCandidateCommentDelete } from "../../api/hooks/useCandidateCommentDelete";
import { useConfirm } from "@am-tax/fe-core";

export const CandidateCommentCards: FunctionComponent<CandidateCommentParameter> = candidateComment => {
    const [commentToDelete, seCommentToDelete] = useState<CandidateCommentParameter | null>(null);
    const deleteCommentFromRequest = useCandidateCommentDelete();
    const { ConfirmDialog, confirm } = useConfirm({ prompt: "Are you sure you want to delete this comment?" });

    const deleteComment = async (comment: CandidateCommentParameter) => {
        console.log("Deleting comment", candidateComment);
        const confirmed = await confirm();

        if (confirmed) {
            seCommentToDelete(comment);
            deleteCommentFromRequest.mutate(comment, {
                onSuccess: async () => {
                    await candidateComment.refetch();
                },
            });
        }
    };

    return (
        <>
            <ConfirmDialog />
            <Card>
                <CardHeader>
                    <Flex justifyContent="space-between">
                        <Text variant={"label"}>Created By: {candidateComment.createdByName}</Text>
                        <Text variant={"label"}>Created On: {candidateComment.createdOn}</Text>
                    </Flex>
                </CardHeader>
                <Divider />
                <CardBody paddingBottom={0}>
                    <Flex direction="column" height="100%">
                        <Stack divider={<StackDivider />} spacing="4">
                            <Text fontSize="md">{candidateComment.body}</Text>
                        </Stack>
                        <Flex justifyContent="flex-end">
                            <IconButton
                                aria-label={"Delete this comment"}
                                p={0}
                                variant={"ghost"}
                                _hover={{ bg: "transparent" }}
                                icon={<Icon as={IconTrash} />}
                                isLoading={deleteCommentFromRequest.isLoading && commentToDelete?.id === candidateComment.id}
                                isDisabled={deleteCommentFromRequest.isLoading}
                                height={"fit-content"}
                                onClick={() => deleteComment(candidateComment)}
                            />
                        </Flex>
                    </Flex>
                </CardBody>

                <CardFooter></CardFooter>
            </Card>
        </>
    );
};
